import React from 'react';
import './styles.css'

const ButtonWhite = ({ label, onPress, large, disabled = false, style }) => (
  <button style={style} className={`ButtonWhite ${large ? 'ButtonLargeWhite' : ''}`} onClick={onPress} disabled={disabled}>
      {label}
  </button>
);

export default ButtonWhite;